import { CommonList } from '$shared/models/CommonList';

export enum SanctionReviewActionType {
  RejectWithNote = 'RejectWithNote'
}

export const getSanctionReviewActionAsList = (): CommonList[] => {
  return [CommonList.create('Add Reject Note', SanctionReviewActionType.RejectWithNote)];
};
